'use client';

import { useAppSelector } from './storeHooks';

export function useUser() {
  const user = useAppSelector((state) => state.auth.user);
  return user;
}
